
import { defineComponent, watch, ref } from 'vue'
import LayoutLeftMenu from './components/layout/left-menu.vue'
import LayoutHeader from './components/layout/header.vue'
import { useSessionModule } from '@/modules/session'
import { useRouter } from 'vue-router'
import { MembersRouteNames, SessionRouteNames } from '@/router/routes-names'

export default defineComponent({
    name: 'layout-default',
    components: {
        LayoutLeftMenu,
        LayoutHeader
    },
    setup () {
        const { isLoggedIn } = useSessionModule()
        const router = useRouter()
        const isDrawerOpen = ref(false)

        watch(isLoggedIn, (current, old) => {
            if ((old && !current) || (!old && !current)) {
                return router.push({ name: SessionRouteNames.LOGIN })
            }
            if (current) {
                const nextRoute = window.localStorage.getItem('nextRoute')
                if (!nextRoute) {
                    return router.push({ name: MembersRouteNames.LIST, query: { page: 1 } })
                } else {
                    window.localStorage.removeItem('nextRoute')
                    return router.push(JSON.parse(nextRoute))
                }
            }
        })

        return {
            isLoggedIn,
            isDrawerOpen
        }
    }
})
